import * as consts from "./const";
import { DataCenter } from "./../DataCenter";
import Stock from "./Stock";
import GameLevel from "./GameLevel";

const { regClass, property } = Laya;

@regClass('VilelMAkTxet4XwP2YHrcw')
export default class LevelLayer {

    public left_points: [number, number][] = [];
    public right_points: [number, number][] = [];
    public gen_width:number = 0;

    public min_size:number = 0;
    public remove_veg:number = 0;
    public veg_weights:number[] = [];
    public w_weights:number[] = [];
    public h_weights:number[] = [];
    public fix_veg:number[] = [];
    public fix_x:number[] = [];
    public fix_y:number[] = [];
    public fix_point_id:number = 0;
    public block_id:number = 0;
    public _spec1:number = 0;
    public _spec2:number = 0;

    public _stocks:Stock[] = [];
    public _stock_point_left:number = 0;
    public _has_stock:boolean = false;


    public _map_veg:number[] = [];
    private _whole_layer_weight:number = 0;
    private _whole_sep_weight:number = 0;
    
    private _pop_count:number = 0;

    private thunder_toy_count:number = 0;
    private _thunder_toy_lst:number[] = [];
    private _cur_thunder_idx:number = 0;

    private unknown_toy_count:number = 0;
    private _unknown_toy_lst:number[] = [];
    private _cur_unknown_idx:number = 0;

    public _clip_y:number = consts.INVLIAD_NUM;
    public _clip_x:number[] = null;
    public _collect_count:number = 0;

    constructor() {
    }

    public init_data(data:any[]) {
        this.min_size = data[0];
        this.remove_veg = data[1];
        this.veg_weights = data[2];
        this.w_weights = data[3];
        this.h_weights = data[4];
        this.fix_veg = data[5];
        this.fix_x = data[6];
        this.fix_y = data[7];
        this.fix_point_id = data[8];
        this.block_id = data[9];
        this._spec1 = data[10];
        this._spec2 = data[11];

        for (let i = 0; i < this.veg_weights.length; i++) {
            for(let j = 0; j < this.veg_weights[i]; j++) {
                this._map_veg.push(i);
            }
        }
        this._whole_layer_weight =0;
        for (let i = 0; i < this.h_weights.length; i++) {
            this._whole_layer_weight += this.h_weights[i];
        }

        this._whole_sep_weight = 0;
        for (let i = 0; i < this.w_weights.length; i++) {
            this._whole_sep_weight += this.w_weights[i];
        }

        this.unknown_toy_count = DataCenter.instance.genSpecialToy(consts.SPECIAL_TYPE_UNKNOWN_TOY, [this._spec1, this._spec2]);
        this.thunder_toy_count = DataCenter.instance.genSpecialToy(consts.SPECIAL_TYPE_THUNDER, [this._spec1, this._spec2]);
        let stocks = DataCenter.instance.getStocks( [this._spec1, this._spec2]);
        
        this._stock_point_left = 0;
        for(let j = 0; j < stocks.length; j++) {
            let toy_num = stocks[j]; 
            if(toy_num == 0) {
                continue;
            }
            let st = GameLevel.instance.addStock(toy_num, j);
            this._stocks.push(st);
            this._stock_point_left += toy_num;
        }
        this._has_stock = this._stocks.length > 0;
        if(this.block_id != 0)
        {
            this._clip_x = DataCenter.instance.getClipXByBlock(this.block_id);
        }
        //this._stock_point_left += this._stock_point_left;//desc + point
    }

    public init_points() {
        this.left_points = [];
        this.right_points = [];
    }

    public add_point(point:[number, number]) {
        if(this._clip_y < consts.INVLIAD_NUM) {
            if(point[1] < this._clip_y) {
                return;
            }
        }
        if(this._clip_x != null) {
            for(let i = 0; i < this._clip_x.length; i += 2) {
                let x = point[0]
                if(x > this._clip_x[i] && x < this._clip_x[i + 1]) {
                    return;
                }
            }
        }
        if(point[0] < this.gen_width/2) {
            this.left_points.push(point);
        } else {
            this.right_points.push(point);
        }
    }

    public remove_points(num:number)
    {
        let len = this.left_points.length + this.right_points.length;
        for (let j = 0; j < num; j++) {

            let idx = Math.floor(Math.random() * len);
            if(idx < this.left_points.length) {
                this.left_points.splice(idx, 1);
            } else {
                this.right_points.splice(idx - this.left_points.length, 1);
            }
            len --;
            if(len <= 0) {
                break;
            }
        }       
    }

    public has_fix_veg(num:number) : boolean {
        return this.fix_veg.length > num;
    }

    public fix_proto_idx(num:number) : number {
        return this.fix_veg[num];
    }

    public fix_sep(num:number) : boolean {
        return this.fix_x[num] == 1;
    }

    public fix_layer_offset(num:number) : number {
        return this.fix_y[num];
    }

    public get_collect() : boolean {
        if(this._collect_count > 0) {
            this._collect_count --;
            return true;
        }
        return false;
    }

    public rand_proto_idx() {
        let r = Math.floor(Math.random() * this._map_veg.length);
        return this._map_veg[r];
    }

    public proto_count() : number {
        let len = this._map_veg.length;
        return this._map_veg[len - 1];
    }

    public rand_layer_offset() {
        let r = Math.floor(Math.random() * this._whole_layer_weight);
        let offset = 0;
        for (let i = 0; i < this.h_weights.length; i++) {
            offset += this.h_weights[i];
            if(r < offset) {
                return i;
            }
        }
        return 0;
    }

    public has_point() {
        return this.left_points.length > 0 || this.right_points.length > 0;
    }

    public has_stock_point() {
        if(this.has_point() && this._pop_count % 2 == 1) {
            return false;
        }
        return this._stock_point_left > 0;
    }

    public pop_stock_point() {
        let left =  this._stock_point_left;
        for(let i = 0; i < this._stocks.length; i++) {
            let st = this._stocks[i];
            if(st.expect_num >= left) {
                return [-10000, i]; //x will add offset, y is layer 0 so no need to add offset
            }
            left -= st.expect_num;
        }
        return null;
    }

    public pop_point() {
        if(this.has_stock_point()) {
            return this.pop_stock_point();
        }
        let len = this.left_points.length + this.right_points.length;
        let idx = Math.floor(Math.random() * len);
        this._pop_count ++;
        if(idx < this.left_points.length) {
            return this.left_points.pop();
        } else {
            return this.right_points.pop();
        }
    }

    public pop_left() {
        if(this.has_stock_point()) {
            return this.pop_stock_point();
        }

        if(this.left_points.length > 0) {
            this._pop_count ++;
            return this.left_points.pop();
        }
        return this.pop_right();
    }

    public pop_right() {
        if(this.has_stock_point()) {
            return this.pop_stock_point();
        }
        
        if(this.right_points.length > 0) {
            this._pop_count ++;
            return this.right_points.pop();
        }
        if(this.left_points.length > 0) {
            this._pop_count ++;
            return this.left_points.pop();
        }
        return null;
    }

    public rand_seperated() : boolean {
        let r = Math.floor(Math.random() * this._whole_sep_weight);
        return r > this.w_weights[0];
    }

    public all_points_ready() : number {        
        let count = this.left_points.length + this.right_points.length;
        this._pop_count = 0;
        
        for(let i = 0; i < this.unknown_toy_count; i++) {            
            let r = Math.floor(Math.random() * count);
            this._unknown_toy_lst.push(r);
        }
        this._unknown_toy_lst.sort((a, b) => a - b);
        this.do_pop_known_lst();

        for(let i = 0; i < this.thunder_toy_count; i++) {            
            let r = Math.floor(Math.random() * count);
            this._thunder_toy_lst.push(r);
        }
        this._thunder_toy_lst.sort((a, b) => a - b);
        this.do_pop_thunder();
        return count
    }

    private do_pop_known_lst() {
        if(this._unknown_toy_lst.length > 0) {
            this._cur_unknown_idx = this._unknown_toy_lst.pop();
            return;
        }
        this._cur_unknown_idx = 10000;
    }
    private do_pop_thunder() {
        if(this._thunder_toy_lst.length > 0) {
            this._cur_thunder_idx = this._thunder_toy_lst.pop();
            return;
        }
        this._cur_thunder_idx = 10000;
    }

    public pop_spec_toy(point:number[]) : number {
        let ret =0;
        if(this._cur_unknown_idx <= this._pop_count) {
            this.do_pop_known_lst();
            ret |= consts.SPECIAL_TYPE_UNKNOWN_TOY;
        }
        if(this._cur_thunder_idx <= this._pop_count) {
            this.do_pop_thunder();
            ret |= consts.SPECIAL_TYPE_THUNDER;
        }
        if(point[0] == -10000) {
            ret |= consts.SPECIAL_TYPE_STOCK;
            this._pop_count ++;
            this._stock_point_left --;
        }
        return ret;
    }

}